import Vue from 'vue';
import { ClickOutside } from '@/directives/clickOutside.directive';

Vue.directive('click-outside', ClickOutside);
